import { useState } from 'react';
import './index.css'

type StoreType = {
    id: number;
    name: string;
    city: string;
    district: string;
    street: string;
    number: string;
    currentBalance: number;
    distance: string;
}

type StoreProps = {
    store: StoreType,
    selectedStore: number | undefined;
    setSelectedStore: (value: number) => void;
}

export function Store({ store, selectedStore, setSelectedStore }: StoreProps) {
    return(
        <div className="store" key={store.id}>
            <div className="main-info">
                <div className="button-select-store">
                    <div className="store-select" onClick={() => setSelectedStore(store.id)}>
                        {selectedStore === store.id &&
                        <div className="checked-store" />
                        }
                    </div>
                </div>
                <div className="store-content">
                    {/* <div className="days">
                        <h2>Retire na loja a partir de 7 dias úteis</h2>
                    </div> */}
                    <div className="title-store">
                        <p style={{fontWeight: 'bold'}}>{ store.name }</p>
                        { store.distance ?
                        <p>{ store.distance } km</p> : <></>}
                    </div>
                    <div className="address-store">
                        <p>
                            { store.street} 
                            { store.number && ', ' + store.number }
                            { store.district && ', ' + store.district }
                            { store.city && ' - ' + store.city } 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}